import $ from 'jquery'
import View from '../../../View'
import LoadingContainer from '../../../util/LoadingContainer'
import {HIDE_ANIMATION_CLASSES, PANEL_TYPES, SHOW_ANIMATION_CLASSES} from '../../../panels/constants'
import PanelContainer from '../../../components/PanelContainer'

export default class ManagementAssignmentsPanel extends View {
    constructor({
        panelContent = null,
        onPanelHide = () => {},
        loadData = () => {},
        additionalClass = '',
    }) {
        super()

        this.params = {
            onPanelHide,
            loadData,
            panelContent,
            additionalClass,
        }

        this.state = {
            isShown: false,
            userPanelOpenedBelow: false,
            needToLoadData: false,
            loading: false,
        }

        this.onStatePropertyChanged('isShown', (isShown) => {
            this.managementAssignmentsPanelContainer.setState({isShown: isShown})
        })

        this.onStatePropertyChanged('userPanelOpenedBelow', (userPanelOpenedBelow) => {
                this.params.panelContent.setState({
                    withBackButton: userPanelOpenedBelow
                })
        })

        this.onStatePropertyBecameTrue('needToLoadData', () => {
            this.params.loadData()
        })

        this.onStatePropertyChanged('loading', (loading) => {
            this.managementAssigmnentLoadingContainer.setState({
                loading: loading
            })
        })
    }

    afterRender() {
        this.managementAssigmnentLoadingContainer = new LoadingContainer({
            contentComponent: this.params.panelContent,
            containerClass: 'managementAssignmentsPanelLoadingWrapper',
            loadingMoireConfig: {
                delay: 500
            }
        })

        this.managementAssignmentsPanelContainer = new PanelContainer({
            component: this.managementAssigmnentLoadingContainer,
            additionalClass: "managementAssignmentsPanelContainer " + this.params.additionalClass,
            showAnimationClass: SHOW_ANIMATION_CLASSES.SLIDE_LEFT,
            hideAnimationClass: HIDE_ANIMATION_CLASSES.SLIDE_LEFT,
            showHideButton: false,
            hideOnEsc: true,
            hideOnClickOutside: {
                hideOnClick: true,
                panelType: PANEL_TYPES.MANAGEMENT_ASSIGNMENTS_PANEL,
            },
            onShowCallback: () => this.params.panelContent.update(),
            onHideCallback: () => this.params.onPanelHide(),
            hideHandler: () => this.managementAssignmentsPanelContainer.setState({isShown: false}),
        }).init($('body'))
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/managementAssignmentsPanel/ManagementAssignmentsPanel.js